import { get, post } from '../api/apiClient';
import { API_ROUTES } from '../shared/apiRoutes/apiRoutes';

/**
 * Preview a panel pairing code before claim (non-sensitive device metadata).
 */
export async function previewPanelPairing(pairingCode) {
  const code = String(pairingCode || '')
    .trim()
    .toUpperCase();
  const url = API_ROUTES.PANEL_PAIRING_PREVIEW.replace(':pairingCode', encodeURIComponent(code));
  const response = await get(url);
  if (!response.success) {
    throw new Error(response.message || response.error || 'Invalid pairing code');
  }
  return response.data || {};
}

/**
 * Claim a Touch Panel into the current administrator's tenant.
 */
export async function claimPanelPairing(pairingCode, { tenantId, backendBaseUrl } = {}) {
  const code = String(pairingCode || '')
    .trim()
    .toUpperCase();
  const url = API_ROUTES.PANEL_PAIRING_CLAIM.replace(':pairingCode', encodeURIComponent(code));
  const body = {};
  if (tenantId) body.tenantId = tenantId;
  if (backendBaseUrl) body.backendBaseUrl = backendBaseUrl;
  const response = await post(url, body);
  if (!response.success) {
    throw new Error(response.message || response.error || 'Claim failed');
  }
  return response.data || {};
}
